import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogDirective } from './dialog.directive';
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [DialogDirective],
  exports: [DialogDirective]
})
export class DialogModule { }
